<template>
  <div>
    <div id="message-pub" class="modal fade" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">ارسال پیام</h4>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">بستن</span>
            </button>
          </div>
          <form class="form-horizontal" v-on:submit.prevent>
            <div class="modal-body">
              <div class="row d-flex align-items-center mb-5">
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" required v-model="modal.title" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>عنوان پیام</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" required v-model="modal.titleEn" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>عنوان انگلیسی</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" required v-model="modal.text" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>متن پیام</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" required v-model="modal.textEn" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>متن انگلیسی</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-shadow" data-dismiss="modal">
                بستن
              </button>
              <button type="submit" class="btn btn-primary" @click="handleClick">
                ذخیره
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modal: {},
  },

  watch: {},
  methods: {
    handleClick() {
      this.$emit('clicked', this.modal);
    },
  },
};
</script>
